export default __webpack_public_path__ + "static/media/php.9a406dd6.svg";